module.exports = __webpack_public_path__ + "static/media/pic4.b868fb7d.jpg";